import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LOGO, LOGO_BLUE } from "../images";
import { loginUser } from "../components/common/common";
import PostRequest from "../servies/PostRequest";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const response = await PostRequest("/login", {
        email,
        password,
      });
      console.log("response", response);

      if (response) {
        window.localStorage.setItem("token", response?.token);
        window.localStorage.setItem("auth", JSON.stringify(response));
        navigate("/forms/t0DoMPhK");
      }
    } catch (err) {
      setError("Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid p-0">
      <div className="row m-0">
        <div className="col-12 p-0">
          <div className="login-card">
            <div>
              <div className="logo text-center">
                <img src={LOGO_BLUE} className="login_logo" />
              </div>
              <div className="login-main">
                <form className="theme-form" onSubmit={handleSubmit}>
                  <h2 className="text-center">Sign in to account</h2>
                  <p className="text-center">
                    Enter your email &amp; password to login
                  </p>
                  {error && <div className="alert alert-danger">{error}</div>}
                  <div className="form-group">
                    <label className="col-form-label">Email Address</label>
                    <input
                      className="form-control"
                      type="email"
                      required
                      placeholder="Enter Your Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <label className="col-form-label">Password</label>
                    <div className="form-input position-relative">
                      <input
                        className="form-control"
                        type="password"
                        name="login[password]"
                        required
                        placeholder="*********"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                      {/* <div className="show-hide">
                        <span className="show"> </span>
                      </div> */}
                    </div>
                  </div>
                  <div className="form-group mb-0">
                    <div className="text-end mt-3">
                      <button
                        className="btn btn-primary btn-block w-100"
                        type="submit"
                        disabled={loading}
                      >
                        {loading ? "Signing in..." : "Sign in"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
